import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import React, { useState, useRef, useEffect, useMemo, useLayoutEffect } from 'react';

import styled from 'styled-components';

import PropyLogo from '../img/propy-dark-mode.svg';
import MenuHamburgerIcon from '../img/menu-hamburger.svg';
import MenuExitIcon from '../img/menu-exit.svg';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import Button from './Button';
import LinkWrapper from './LinkWrapper';

import useWindowSize from '../hooks/useWindowSize';

import {
  MENU_ENTRIES,
  PROPY_SPACE_GREY_DARK,
  debounce,
  ONBOARDING_ROOT,
} from '../utils';

import {
  IdentityServerPropyAuthority,
  storeAuthTokens,
  signOutClearAuthTokens,
} from '../services/auth';

import {
  UserService,
} from '../services/api';


// const TopPaddingZone = styled.div`
//   background-color: black;
//   height: ${props => props.theme.spacing(4)};
//   z-index: 1;
//   position: relative;
// `

const ZoneContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  background-color: ${props => (props.scrolled || props.forceOpacity) ? 'rgb(0 0 0 / 95%)' : 'transparent'};
  // background-color: ${props => props.scrolled ? '#000000cc' : 'transparent'};
  // backdrop-filter: ${props => props.scrolled ? 'blur(8px)' : 'none'};
  top: 0px;
  position: sticky;
  z-index: 200;
  transition: background-color 0.1s ease-in-out;
`;

const ZoneContainerInner = styled.div`
  max-width: 1080px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: ${props => props.mobile ? props.theme.spacing(2) : props.theme.spacing(0)}
  padding-right: ${props => props.mobile ? props.theme.spacing(1) : props.theme.spacing(0)}
`

const MenuItemsContainer = styled.div`
  display: flex;
  align-items: center;
`

const MenuItemButton = styled(Typography).withConfig({
  shouldComponentUpdate: true,
})`
  padding-top: ${props => props.theme.spacing(2)};
  padding-bottom: ${props => props.theme.spacing(2)};
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: ${fonts.spaceGrotesk}!important;
  font-weight: 500!important;
  font-size: 13px!important;
  letter-spacing: 0.06rem!important;
  text-transform: uppercase;
  margin-right: ${props => props.includemarginright ? props.theme.spacing(6) : 0}!important;
  color: ${props => props.featured ? 'rgb(56 166 251 / 100%)' : 'rgb(255 255 255 / 50%)'};
  
  &:hover {
    color: ${props => props.featured ? 'rgb(255 255 255 / 100%)' : 'rgb(255 255 255 / 100%)'};
  }
`

const MobileMenuItemButton = styled(Typography).withConfig({
  shouldComponentUpdate: true,
})`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: ${props => props.theme.spacing(1)};
  padding-bottom: ${props => props.theme.spacing(1)};
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: ${fonts.spaceGrotesk}!important;
  font-weight: 500!important;
  font-size: 13px!important;
  letter-spacing: 0.06rem!important;
  text-transform: uppercase;
  margin-right: ${props => props.includemarginright ? props.theme.spacing(6) : 0}!important;
  color: ${props => {
    if(props.featured) {
      return 'rgb(56 166 251 / 100%)';
    } else if (props.expanded) {
      return 'rgb(255 255 255 / 100%)';
    } else {
      return 'rgb(255 255 255 / 50%)';
    }
  }};
`

const ListItemButtonCustom = styled(ListItemButton)`
  
  &:hover {
    ${MobileMenuItemButton} {
      color: rgb(255 255 255 / 100%);
      font-weight: 400!important;
    }
  }
`

const FlyoutContainer = styled(motion.div)`
  background-color: rgb(0 0 0 / 95%);
  // background-color: #000000cc;
  // backdrop-filter: blur(8px);
  position: absolute;
  width: 100%;
  top: 100%;
  left: 0;
  overflow: hidden;
  color: white;
  display: flex;
  justify-content: center;
  z-index: 200;
`

const FlyoutContainerInner = styled(motion.div)`
  padding-top: ${props => props.theme.spacing(4)};
  max-width: 1080px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing(4)}; // Add some spacing between columns
`

const FlyoutRightColumn = styled(motion.div)`
  // background-color: red;
  height: 300px;
  width: ${props => props.width - 32}px;
`

const FlyoutLeftColumn = styled(motion.div)`
  max-width: 380px;
  height: 300px;
  width: ${props => 1080 - (props.$rightColumnWidth < 750 ? props.$rightColumnWidth : 750)}px; // 32px is the gap (theme.spacing(4))
  flex-shrink: 0; // Prevent shrinking
`

const LeftColumnSubtitle = styled(Typography)`
  font-family: ${fonts.robotoMono}!important;
  font-weight: 300!important;
  font-size: 15px!important;
  letter-spacing: -0.03rem!important;
`

const LeftColumnButton = styled(Button)`

`

const MenuItemInnerFlyoutButton = styled(Typography)`
  cursor: pointer;
  font-family: ${fonts.robotoMono}!important;
  font-weight: 300!important;
  font-size: 15px!important;
  letter-spacing: -0.03rem!important;
  color: rgb(255 255 255 / 50%);
  
  &:hover {
    color: rgb(255 255 255 / 100%);
    font-weight: 400!important;
  }
`

const ExitContainer = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: ${props => props.theme.spacing(1.5)};
  padding-left: ${props => props.theme.spacing(2)};
`

const PropyLogoBox = styled(Box).withConfig({
  shouldComponentUpdate: true,
})`
  width: 128px;
  height: ${props => props.mobile ? '28px' : '40px'};
  margin-top: 14px;
  margin-bottom: 14px;
`

const MobileSubmenuContainer = styled(motion.div)`
  overflow: hidden;
  padding-bottom: ${props => props.theme.spacing(1)};
`

const MobileSubmenuItem = styled(Typography)`
  padding-left: ${props => props.theme.spacing(2)};
  padding-right: ${props => props.theme.spacing(2)};
  padding-bottom: ${props => props.theme.spacing(1)};
  color: rgb(255 255 255 / 50%);
  font-family: ${fonts.robotoMono}!important;
  font-size: 14px!important;
  
  &:hover {
    color: rgb(255 255 255 / 100%);
  }
`

const NavBar = ({ 
  isConsideredMobile,
  setSignedIn,
  signedIn,
  isHeroVisible,
  setConsideredMobile,
  setConsideredMedium,
  forceOpacity,
}) => {

  const [hoveredItem, setHoveredItem] = useState(null);
  const [menuItemsWidth, setMenuItemsWidth] = useState(0);
  const [open, setOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [scrolled, setScrolled] = useState(0);
  
  const menuItemsRef = useRef(null);

  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setScrolled(latest > 32 ? true : false);
  })

  const filteredMenuEntries = useMemo(() => 
    MENU_ENTRIES.filter(entry => {
      if (signedIn) {
        if(!isHeroVisible && !signedIn && entry.hideHeroInvisibleSignedIn) {
          return !entry.hideHeroInvisibleSignedIn
        }
        return !entry.hideSignedIn;
      } else {
        if(!isHeroVisible && !signedIn && entry.hideHeroInvisibleSignedOut) {
          return !entry.hideHeroInvisibleSignedOut
        }
        return !entry.hideSignedOut;
      }
    }),
    [signedIn, isHeroVisible]
  );

  const handleMenuItemClick = (menuId) => {
    setExpandedItems(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const handleMouseEnter = (item) => {
    if (item.desktopFlyoutHeight) {
      setHoveredItem(item);
    } else {
      setHoveredItem(null);
    }
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  useEffect(() => {
    const menuItems = menuItemsRef.current;
    
    const updateWidth = debounce(() => {
      if (menuItems) {
        setMenuItemsWidth(menuItems.offsetWidth);
      }
    }, 150);
    
    updateWidth();
    
    window.addEventListener('resize', updateWidth);
    
    return () => {
      window.removeEventListener('resize', updateWidth);
      updateWidth.cancel();
    };
  }, []);

  useEffect(() => {
    if(isConsideredMobile && hoveredItem) {
      setHoveredItem(null);
    } else if (!isConsideredMobile && open) {
      setOpen(false);
    }
  }, [isConsideredMobile, hoveredItem, open])

  // refresh token logic for auth
  useEffect(() => {

    function checkUserData() {
      if (setSignedIn) {
        try {
          const accessToken = localStorage.getItem('propyAccessToken');
          setSignedIn(!!accessToken);
        } catch (error) {
          console.error('Error checking authentication status:', error);
          setSignedIn(false);
        }
      }
    }

    const runAuthRefresh = async () => {
      if(setSignedIn) {
        try {
          let currentRefreshToken = localStorage?.getItem('propyRefreshToken');
          if(currentRefreshToken) {
            let currentExpiryTime = localStorage?.getItem('propyExpiryToken');
            if(currentExpiryTime) {
              let timeToExpire = Math.floor(Number(currentExpiryTime) / 1000) - Math.floor(new Date().getTime() / 1000);
              console.log("Access token expires in seconds:", timeToExpire)
              if(timeToExpire <= 60) {
                console.log("Refreshing access token due to expiry in seconds:", timeToExpire);
                let refreshTokensResponse = await UserService.refreshAuth(currentRefreshToken);
                let {
                  refresh_token,
                  access_token,
                  expires_in,
                  auth_time,
                  profile,
                  scope,
                  token_type,
                } = refreshTokensResponse;
                if(refresh_token && access_token && expires_in && auth_time && profile) {
                  setSignedIn(true);
                  storeAuthTokens(access_token, refresh_token, expires_in, auth_time);
                  let idServer = new IdentityServerPropyAuthority();
                  idServer.setUser({
                    access_token,
                    refresh_token,
                    token_type,
                    scope,
                    profile,
                    expires_at: (Number(auth_time) + expires_in).toString(),
                  })
                } else {
                  setSignedIn(false);
                }
              }
            }
          }
        } catch (e) {
          setSignedIn(false);
          signOutClearAuthTokens();
          console.error("unable to refresh auth tokens");
          console.error({error: e})
        }
      }
    };

    checkUserData();
    runAuthRefresh();
  
    const intervalId = setInterval(runAuthRefresh, 20000);

    window.addEventListener('storage', checkUserData)
  
    return () => {
      window.removeEventListener('storage', checkUserData);
      clearInterval(intervalId);
    }
  }, [setSignedIn]);

  const windowSize = useWindowSize();

  useLayoutEffect(() => {
    let sizeConsiderMobile = 1100;
    let sizeConsideredMedium = 1535;
    if (windowSize.clientWidth && (windowSize.clientWidth <= sizeConsiderMobile)) {
      setConsideredMobile(true);
    } else if (windowSize.clientWidth) {
      setConsideredMobile(false);
    }
    if (windowSize.clientWidth && (windowSize.clientWidth <= sizeConsideredMedium)) {
      setConsideredMedium(true);
    } else if (windowSize.clientWidth) {
      setConsideredMedium(false);
    }
  }, [windowSize.clientWidth, windowSize.clientHeight, windowSize.width, windowSize.height, setConsideredMobile, setConsideredMedium])

  return (
    <>
      {/* {!isConsideredMobile && <TopPaddingZone />} */}
      <ZoneContainer scrolled={scrolled} forceOpacity={forceOpacity}>
        <ZoneContainerInner
          mobile={isConsideredMobile}
        >
          <PropyLogoBox
            component={PropyLogo}
            mobile={isConsideredMobile}
          />
          <MenuItemsContainer ref={menuItemsRef}>
            {!isConsideredMobile && filteredMenuEntries.map((item, index) => {
              return (
                <LinkWrapper
                  key={`menu-entry-${item.id}-${index}`}
                  link={item.link ? item.link : false}
                  external={item.external ? true : false}
                >
                  <MenuItemButton
                    includemarginright={index < (filteredMenuEntries.length - 1)}
                    featured={item.featuredEntry ? true : false}
                    onMouseEnter={() => handleMouseEnter(item)}
                    // onMouseLeave={handleMouseLeave}
                  >
                    {item.label}
                    {(item.innerEntries?.length > 0) && <ExpandMoreIcon/>}
                  </MenuItemButton>
                </LinkWrapper>
              )
            })}
            <AnimatePresence>
              {!isConsideredMobile && !signedIn && !isHeroVisible &&
                <motion.div
                  style={{position: 'relative'}}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ enter: { duration: 0.2, ease: "easeInOut"}, exit: { duration: 0 } }}
                >
                  <LinkWrapper link={`${ONBOARDING_ROOT}/get-started`} external={true} noFlex={true}>
                    <Button
                      text="Get Started"
                      marginLeft={'32px'}
                      marginRight={'16px'}
                      marginBottom={'0px'}
                      width={"auto"}
                      paddingLeft="0px"
                      paddingRight="0px"
                      fontSize="12px"
                      slim={true}
                    />
                  </LinkWrapper>
                  <LinkWrapper link={`${ONBOARDING_ROOT}/get-started/agent`} external={true} noFlex={true}>
                    <Button
                      text="Book a Demo"
                      color="secondary"
                      width={"auto"}
                      paddingLeft="0px"
                      paddingRight="0px"
                      fontSize="12px"
                      slim={true}
                    />
                  </LinkWrapper>
                </motion.div>
              }
            </AnimatePresence>
            {isConsideredMobile &&
              <Stack direction="row" spacing={1}>
                <IconButton color="secondary" onClick={() => setOpen(true)} aria-label="menu">
                  <Box 
                    component={MenuHamburgerIcon}
                  />
                </IconButton>
              </Stack>
            }
          </MenuItemsContainer>
        </ZoneContainerInner>
        <AnimatePresence>
          {hoveredItem && (
            <FlyoutContainer
              initial={{ height: 0 }}
              animate={{ height: hoveredItem.desktopFlyoutHeight }}
              exit={{ height: 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
              onMouseEnter={() => setHoveredItem(hoveredItem)}
              onMouseLeave={handleMouseLeave}
            >
              <FlyoutContainerInner>
                <FlyoutLeftColumn $rightColumnWidth={menuItemsWidth}>
                  <LeftColumnButton
                    text={hoveredItem.desktopFlyoutTitle}
                    link={hoveredItem.ctaLink}
                    externalLink={true}
                    color="info"
                    variant="outlined"
                    marginBottom={'16px'}
                    slim={true}
                  />
                  <LeftColumnSubtitle>{hoveredItem.desktopFlyoutDescription}</LeftColumnSubtitle>
                </FlyoutLeftColumn>
                <FlyoutRightColumn width={menuItemsWidth}>
                  {hoveredItem?.innerEntries && hoveredItem?.innerEntries?.length > 0 &&
                    <Grid container spacing={4}>
                      {hoveredItem?.innerEntries?.map((column, index) => 
                        <Grid item md={6} key={`desktop-menu-entry-${hoveredItem.id}-${index}`}>
                            {column?.map((row, rowIndex) => 
                              <div key={`desktop-menu-entry-${index}-${rowIndex}`}>
                                <LinkWrapper onClick={() => setHoveredItem(null)} link={row.link} external={row.external}>
                                  <MenuItemInnerFlyoutButton>
                                    {row.label}
                                  </MenuItemInnerFlyoutButton>
                                </LinkWrapper>
                              </div>
                            )}
                        </Grid>
                      )}
                    </Grid>
                  }
                </FlyoutRightColumn>
              </FlyoutContainerInner>
            </FlyoutContainer>
          )}
        </AnimatePresence>
        <Drawer 
          sx={{
            '.MuiDrawer-paper': {
              backgroundColor: 'black',
            }
          }}
          anchor={'right'}
          open={open}
          onClose={() => setOpen(false)}
        >
          <Box sx={{ width: '100vw' }} role="presentation">
            <ExitContainer>
              <PropyLogoBox
                component={PropyLogo}
                onClick={() => setOpen(false)}
              />
              <Stack direction="row" spacing={1}>
                <IconButton color="secondary" onClick={() => setOpen(false)} aria-label="menu">
                  <Box 
                    component={MenuExitIcon}
                  />
                </IconButton>
              </Stack>
            </ExitContainer>
            <List>
              {filteredMenuEntries.map((menuEntry, index) => (
                <React.Fragment key={`mobile-menu-entry-${index}`}>
                  <ListItem disablePadding>
                    <LinkWrapper 
                      link={menuEntry.link ? menuEntry.link : null}
                      external={menuEntry.external ? true : null}
                    >
                      <ListItemButtonCustom onClick={() => handleMenuItemClick(menuEntry.id)}>
                        <MobileMenuItemButton
                          expanded={expandedItems[menuEntry.id] ? true : false}
                        >
                          {menuEntry.label}
                          <motion.div
                            animate={{ rotate: expandedItems[menuEntry.id] ? 180 : 0 }}
                            transition={{ duration: 0.2 }}
                            style={{ height: '20px', marginTop: '-1px' }}
                          >
                            {(menuEntry.innerEntries?.length > 0) && <ExpandMoreIcon style={{ lineHeight: '0px' }}/>}
                          </motion.div>
                        </MobileMenuItemButton>
                      </ListItemButtonCustom>
                    </LinkWrapper>
                  </ListItem>
                  {menuEntry.innerEntries?.length > 0 && (
                    <AnimatePresence>
                      {expandedItems[menuEntry.id] && (
                        <MobileSubmenuContainer
                          initial={{ height: 0 }}
                          animate={{ height: "auto" }}
                          exit={{ height: 0 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}
                        >
                          {menuEntry.innerEntries.flat().map((subItem, subIndex) => (
                            <LinkWrapper 
                              key={`submenu-item-${index}-${subIndex}`}
                              link={subItem.link}
                              external={subItem.external}
                            >
                              <MobileSubmenuItem>
                                {subItem.label}
                              </MobileSubmenuItem>
                            </LinkWrapper>
                          ))}
                        </MobileSubmenuContainer>
                      )}
                    </AnimatePresence>
                  )}
                  <Divider style={{borderColor: PROPY_SPACE_GREY_DARK}} />
                </React.Fragment>
              ))}
            </List>
          </Box>
        </Drawer>
      </ZoneContainer>
    </>
  );
};

export default NavBar;